import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { FormValidators } from '@corelabs/angular-forms';
import { CustomFormGroup, CustomPricing, RelatedEntityType, TierFormGroup, TierPricing } from './types';
import { tierArrayValidator } from './tier-array.validator';

const CENTS_IN_UNIT = 100;

export function createTierGroup(tier?: Partial<TierPricing>): TierFormGroup {
    return new FormGroup({
        label: new FormControl(tier?.label ?? '', { nonNullable: true, validators: [FormValidators.Required] }),
        minUsers: new FormControl(tier?.minUsers ?? 1, { nonNullable: true, validators: [FormValidators.Required] }),
        maxUsers: new FormControl<number | null>(tier?.maxUsers ?? null, { nonNullable: true }),
        price: new FormControl((tier?.price ?? 0) / CENTS_IN_UNIT, {
            nonNullable: true,
            validators: [FormValidators.Required, FormValidators.MinValue(0)],
        }),
    });
}

export function createTierFormArray(tiers?: TierPricing[]): FormArray<TierFormGroup> {
    const controls = tiers?.map((tier) => createTierGroup(tier)) ?? [];
    return new FormArray<TierFormGroup>(controls, [tierArrayValidator]);
}

export function createCustomGroup(custom?: CustomPricing): CustomFormGroup {
    return new FormGroup({
        relatedEntityType: new FormControl<RelatedEntityType>(custom?.relatedEntityType ?? 'school', {
            nonNullable: true,
            validators: [FormValidators.Required],
        }),
        relatedEntityId: new FormControl(custom?.relatedEntityId ?? '', { nonNullable: true, validators: [FormValidators.Required] }),
        pricingList: createTierFormArray(custom?.pricingList),
    });
}

export function createCustomFormArray(items?: CustomPricing[]): FormArray<CustomFormGroup> {
    const controls = items?.map((custom) => createCustomGroup(custom)) ?? [];
    return new FormArray<CustomFormGroup>(controls);
}

export function tierGroupToValue(group: TierFormGroup): TierPricing {
    const raw = group.getRawValue();
    return {
        label: raw.label,
        minUsers: raw.minUsers,
        maxUsers: raw.maxUsers,
        price: Math.round(raw.price * CENTS_IN_UNIT),
    };
}

export function customGroupToValue(group: CustomFormGroup): CustomPricing {
    return {
        relatedEntityType: group.controls.relatedEntityType.value,
        relatedEntityId: group.controls.relatedEntityId.value,
        pricingList: group.controls.pricingList.controls.map((tier) => tierGroupToValue(tier)),
    };
}
